import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { callApi } from '../../../api/call';
import { findCompanyBySlug } from '../../../client-experience/utils/companyAccess';
import '../../styles/LandingPage.css';

const StorefrontDeluxeBookingSuccessPage = () => {
  const { companyUrl, appointmentId } = useParams();
  const [error, setError] = useState(null);
  const [subtitle, setSubtitle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const company = await findCompanyBySlug(companyUrl);
        if (!company?.id) throw new Error('Business not found.');
        const { data } = await callApi(
          `/api/companies/${encodeURIComponent(company.id)}/payments/deluxe/finalize`,
          { companyId: company.id, appointmentId },
          { auth: false }
        );
        const pub = data?.appointment?.publicNumber;
        if (!cancelled && pub != null && /^\d+$/.test(String(pub))) {
          setSubtitle(`Appointment #${pub}`);
        }
      } catch (e) {
        if (!cancelled) setError(e?.message || 'Something went wrong confirming your booking.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [companyUrl, appointmentId]);

  return (
    <div className="landing-page">
      <div className="container" style={{ padding: '48px 16px', textAlign: 'center' }}>
        {loading ? <p>Confirming your payment…</p> : null}
        {!loading && error ? <p>{error}</p> : null}
        {!loading && !error ? (
          <>
            <h1>Payment confirmed</h1>
            {subtitle ? <p>{subtitle}</p> : null}
            <p>Your appointment is booked.</p>
            <Link to={`/book/${companyUrl}`}>Back to booking</Link>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default StorefrontDeluxeBookingSuccessPage;
